import app from 'flarum/common/app';
import extractText from 'flarum/common/utils/extractText';
// Em caso de falha mostra o alerta e resolve null, para quem chama não
// repetir o mesmo .catch().
export default async function apiCall(options, opts) {
  if (opts === void 0) {
    opts = {};
  }
  try {
    // Sem o `errorHandler` o core mostraria um segundo alerta.
    return await app.request({
      errorHandler: () => {},
      ...options
    });
  } catch (raw) {
    const err = raw;
    if (!opts.silent) {
      const detail = err?.response?.errors?.[0]?.detail;
      const title = err?.response?.errors?.[0]?.title;
      let msg;
      if (detail) {
        msg = detail;
      } else if (title) {
        msg = title;
      } else if (!err?.response) {
        msg = extractText(app.translator.trans('ramon-verified.lib.errors.network'));
      } else {
        msg = extractText(app.translator.trans(opts.errorKey || 'ramon-verified.lib.errors.generic'));
      }
      app.alerts.show({
        type: 'error'
      }, msg);
    }
    if (opts.rethrow) throw raw;
    return null;
  }
}
flarum.reg.add('ramon-verified', 'common/utils/apiCall', apiCall);